import React from 'react';
import PropTypes from 'prop-types';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { ConsumerReviewsEntities } from 'client/data/models/consumer-reviews';
import { VehicleModule } from 'site-modules/write-review/components/vehicle-module/vehicle-module';
import { DisclaimerInfo } from 'site-modules/write-review/components/disclaimer-info/disclaimer-info';
import { SubmitButton } from 'site-modules/write-review/components/submit-button/submit-button';
import { AdditionalRatings } from 'site-modules/write-review/components/additional-ratings/additional-ratings';
import { AuthorInfo } from 'site-modules/write-review/components/author-info/author-info';
import { ThankYouText } from './thank-you-text';

export function MoreRatingsAndAuthorInfo({
  reviewData = null,
  fieldRef,
  onSubmit,
  validate,
  vehicle,
  isLoading = false,
}) {
  return (
    <div className="more-ratings-and-author-info-step">
      <h1 className="heading-2 mb-1_5">Write a Review</h1>
      <VehicleModule vehicle={vehicle} showChangeButton={false} />
      <ThankYouText isUpdateForm={!!reviewData} />
      <hr className="my-1_5" />
      <div className="heading-3 mb-1_5">Tell us more (optional)</div>
      <AdditionalRatings fieldRef={fieldRef} validate={validate} reviewData={reviewData} />
      <AuthorInfo fieldRef={fieldRef} validate={validate} reviewData={reviewData} />
      <SubmitButton
        onClick={onSubmit}
        isLoading={isLoading}
        isUpdateForm={!!reviewData}
        dataTrackingId="wr_submit_step_3"
      />
      <DisclaimerInfo />
    </div>
  );
}

MoreRatingsAndAuthorInfo.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  validate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fieldRef: PropTypes.func.isRequired,
  reviewData: ConsumerReviewsEntities.ReviewData,
  isLoading: PropTypes.bool,
};
